/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageTitle} from '../../../../_designereyes/layout/core'
import {BrandSearchSeller} from '../../../../_designereyes/partials/widgets'

const SellerSearchPage: FC = () => {
  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-12 col-lg-12'>
          <BrandSearchSeller className='h-md-50 mb-5 mb-xl-10 h-lg-100' />
        </div>
      </div>
    </>
  )
}

const SellerSearchWrapper: FC = () => {
  return (
    <>
      <PageTitle>BI Seller Research Tool</PageTitle>
      <SellerSearchPage />
    </>
  )
}

export {SellerSearchWrapper}
